<template>
  <main>
    <HeaderMain type="-fluid" />

    <section class="c-section c-section--edit container py-4 py-lg-5">
      <div class="row gy-4">
        <div class="col-12 col-md-4 col-lg-3">
          <aside class="bg-white br--small p-3 p-lg-4 text-center">
            <div class="row gy-3">
              <div class="col-12">
                <div class="d-flex justify-content-center">
                  <div
                    class="c-profile-avatar c-avatar c-avatar--big position-relative"
                    :class="{'uploading' : isUpdating}"
                  >
                    <figure class="c-avatar__image rounded-circle overflow-hidden">
                      <img
                        class="w-100 h-100 of--cover"
                        :src="avatar"
                        alt=""
                      />
                    </figure>
                    <div class="c-profile-avatar__loading position-absolute w-100 h-100">
                      <img
                        class="c-profile-avatar__spinner"
                        src="@/assets/images/animations/spinner-white.png"
                        alt="loading"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <label class="c-link mb-1">
                  <span>Cambiar foto de perfil</span>

                  <input
                    type="file"
                    @change="avatarFileChanged($event)"
                    accept=".jpg,.png,.jpeg"
                    class="d-none"
                  >
                </label>
                <p class="fs-14 w-medium dark-gray">Recuerda subir una imagen de máximo 5MB</p>
              </div>
              <div class="col-12">
                <router-link
                  to="/editar/password"
                  class="c-button c-button--primary-ghost d-block text-center small"
                >
                  Cambiar contraseña
                </router-link>
              </div>
              <div v-if="false" class="col-12">
                <h2 class="fs-16 text-start w-sbold d-block mt-2 mb-0">Asociar cuenta a:</h2>
              </div>
              <div v-if="false" class="col-12">
                <button
                  class="c-button c-button--google d-flex h-100 small
                    w-100 align-items-center justify-content-center"
                >
                  <img src="@/assets/images/icons/google.svg" />
                  <span class="ms-2">Google</span>
                </button>
              </div>
              <div v-if="false" class="col-12">
                <button
                  class="c-button c-button--facebook d-flex h-100 small
                    w-100 align-items-center justify-content-center"
                >
                  <i class="icon-facebook d-flex align-items-center fs-18"></i>
                  <span class="ms-2">Facebook</span>
                </button>
              </div>
            </div>
          </aside>
        </div>
        <div class="col-12 col-md-8 col-lg-9">
          <div class="c-navigator bg-white px-3 br--small mb-4">
            <nav class="c-navigator__items d-flex">
              <router-link
                to="/editar"
                class="c-navigator-item py-2 d-flex position-relative">
                <p class="c-navigator-item__title w-sbold mb-0">Información basica</p>
              </router-link>
              <router-link
                v-if="$route.query.connecta"
                to="/editar/conecta"
                class="c-navigator-item py-2 d-flex position-relative">
                <p class="c-navigator-item__title w-sbold mb-0">Perfil conecta</p>
              </router-link>
            </nav>
          </div>

          <section class="bg-white br--small p-3 p-lg-4">
            <router-view keep-alive />
          </section>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      avatar: '',
      avatarFile: null,

      isUpdating: false,
    };
  },
  computed: {
    ...mapState({
      userData: (state) => state.user.userData,
    }),
  },
  watch: {
    userData(data) {
      this.avatar = data.photo;
    },
  },
  mounted() {
    if (this.userData) {
      this.avatar = this.userData.photo;
    }
  },
  components: {
    HeaderMain: () => import(/* webpackChunkName: "header-main" */'../components/Header.vue'),
  },
  methods: {
    avatarFileChanged(event) {
      const files = event.target.files || event.dataTransfer.files;

      if (!files.length) {
        this.avatarFile = '';

        return;
      }

      [this.avatarFile] = files;

      this.uploadAvatar();
    },
    uploadAvatar() {
      const request = `${window.arcux.api}/users/${this.userData.id}/profile/update`;
      const formData = new FormData();

      formData.append('avatar', this.avatarFile);

      this.isUpdating = true;

      fetch(request, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
        body: formData,
      })
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            const fileReader = new FileReader();

            fileReader.onload = () => {
              this.avatar = fileReader.result;
            };

            fileReader.readAsDataURL(this.avatarFile);
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isUpdating = false;
        });
    },

    isActive(section) {
      let className = '';

      if (this.$route.query.type) {
        className = (this.$route.query.type === section) ? 'active' : '';
      } else {
        className = (section === 'main') ? 'active' : '';
      }

      return className;
    },
  },
};
</script>
